module.exports = require("embed-video");